// extracted by mini-css-extract-plugin
export default {"editAudioItemPanel":"MD945MOBOWVLTy7hIheQ","bottomBar":"PWPQdiTqSjByCxV98mSD","replacePopupWidth":"x0KSWzY2mZpKgOqQjPVK","replacePopupWidthSmall":"gpeMhxUf3w28lSyhIyiN"};